<template>
    <div>
        <div class="placeholder padding mb-4" v-if="$auth.user().company.api_provider.slug === 'minuba'">
            <b>
                Hvordan skal værdien af værdikæden beregnes?
                &nbsp;
                <d-tooltip placement="inline" :identifier="'settings.budget_calc'" />
            </b>
            <br><br>
            <label class="mr-4">
                <input type="radio" name="budget-calculation" value="calculation" v-model="budgetCalc" @change="selectBudgetCalc('calculation')">
                Kalkulation
            </label>
            <label class="mr-4">
                <input type="radio" name="budget-calculation" value="budget" v-model="budgetCalc" @change="selectBudgetCalc('budget')">
                Budget
            </label>
            <label>
                <input type="radio" name="budget-calculation" value="both" v-model="budgetCalc" @change="selectBudgetCalc('both')">
                Budget + kalkulation
            </label>
        </div>
    </div>
</template>

<script>
import * as companyService from '@/services/companyService'

export default {
    data () {
        return {
            budgetCalc: null
        }
    },
    mounted () {
        this.getBudgetSetting()
    },
    methods: {
        getBudgetSetting () {
            companyService.budgetCalc({}, (response) => {
                this.budgetCalc = response.data
            }, (err) => {
                console.log(err)
            })
        },
        selectBudgetCalc (type) {
            let body = {
                budgetCalc: type
            }
            companyService.updateBudgetCalc(body, (response) => {
                console.log(response)
                this.getBudgetSetting()
                this.$toastr('success', 'Budget indstillingen blev opdateret', 'Sådan!')
            }, (err) => {
                console.log(err)
            })
        }
    }
}
</script>



// WEBPACK FOOTER //
// valuechainCalculation.vue?6f6f7e3a